import { CardSkeleton, DashCard } from "../DashboardCards";
import { COLORS, PIE_COLORS } from "../../configs/config";
import { Box, Typography } from "@mui/material";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

export const CostCenterChart = ({ data, loading }) => {
    if (loading) return <CardSkeleton height={160} />;

    const rows = (data ?? []).slice(0, 4).map((d, i) => ({
        ...d,
        color: PIE_COLORS[i] ?? COLORS.tDim,
    }));

    return (
        <DashCard title="Consumo por centro de custo" tag="% do total">
            <Box display="flex" alignItems="center" gap={2}>
                <Box sx={{ position: "relative", height: 110, width: 110, flexShrink: 0 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={rows}
                                cx="50%"
                                cy="50%"
                                innerRadius={30}
                                outerRadius={48}
                                dataKey="percentual"
                                paddingAngle={3}
                                cornerRadius={3}
                            >
                                {rows.map((d, i) => <Cell key={i} fill={d.color} />)}
                            </Pie>
                            <Tooltip
                                formatter={(v) => [`${Number(v).toFixed(1)}%`]}
                                contentStyle={{
                                    background: COLORS.card,
                                    border: `1px solid ${COLORS.border}`,
                                    borderRadius: 8,
                                    fontSize: 11,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                }}
                                itemStyle={{ color: COLORS.tDim }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </Box>
                <Box display="flex" flexDirection="column" gap={0.75} flex={1} minWidth={0}>
                    {rows.map((d, i) => (
                        <Box key={i} display="flex" alignItems="center" gap={0.75}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: d.color, flexShrink: 0 }} />
                            <Typography variant="caption" sx={{
                                color: COLORS.tDim, flex: 1,
                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                            }}>
                                {d.nomeCentroCusto}
                            </Typography>
                            <Typography variant="caption" sx={{ color: COLORS.tSec, fontWeight: 700 }}>
                                {Number(d.percentual ?? 0).toFixed(1)}%
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </DashCard>
    );
};